const det_bottom =
        <>
            <p>Нашли ошибку или есть дополнения?</p>
            <p>Пожалуйста, дайте знать {'->'} <b><a target='_blank' rel="noreferrer" className='' href="https://t.me/remapru_bot">тг-бот</a></b></p>
        </>


const sb_bottom =
    <>
        <span className='p-2 '>Мы еще не добавили протестов за этот период ;(</span>
        <p>Знаете про протест? Пишите {'->'}
            <b><a rel="noreferrer" target='_blank' className='' href="https://t.me/remapru_bot">тг-бот</a></b>
        </p>
    </>

const sb_bottom2 =
    <>
        <p>
            В указаный период  протесты закончились.
        </p>
        <p>
            Чтобы увидеть больше протестов, выберите другой период.
        </p>
    </>

export const ru = {
    name: 'ru',
    title: 'Русский',
    header: {
        title: 'Хроника протестов в России',
        join_button: 'Присоединиться',
        map_button: 'Карта',

    },
    join_page: {
        group_list: {
            title: 'Перечень протестных групп',
            desc: 'Выбирай подходящую группу по интересам и геолокации',
            footer: 'Вы группа и вас нет в списке? -> @remapru_bot',
        },
        send_protests_us: {
            title: 'Присылай протесты нам',
            desc: 'Помощь в наполнении ресурса - огромный вклад',
            text: '',
        }
    },
    main_page: {
        apply: 'Применить',
        side_bar:{
            navigation:{
                news_list: 'Лента протестов',
                news_mob_list: 'Лента',
                archive: 'Архив',
                map: 'Карта',
                more: 'Детальнее',
                less: 'Закрыть',
            },
            list:{
                more: 'Детальнее',
                url: 'Источник',
                no_url: 'Без источника',
            },
            det_bottom: det_bottom,
            archive: {
                title: 'Архив протестов',
                week: 'неделя',
            },
            sb_bottom: sb_bottom,
            sb_bottom2: sb_bottom2,

        }
    }
}

